import React from 'react';

import RoomOption from './roomOption';

export default function RoomOptionContainer({ rooms, selectedRooms, onClick, readOnly }) {
  const renderOptionComponents = () => {
    return rooms.map((room) => {
      return (
        <RoomOption
          key={room.type}
          selected={selectedRooms.find((selectedRoom) => selectedRoom.type === room.type)}
          room={{ code: 1 }}
          onClick={() => onClick(room)}
          readOnly={readOnly}
        >
          <room.icon />
          <div>{room.name}</div>
        </RoomOption>
      );
    });
  };

  return <div className="room-options-container block-container">{renderOptionComponents()}</div>;
}
